export default "__VITE_ASSET__A6fK1i6m__"